import type { ExtendedMantineColor } from '@/mantime';

// TOOD: Export getColorVar and remove the colorVar export
export const getColorVar = (
  colorName: ExtendedMantineColor,
  shade: number = 0
): string => {
  return `var(--mantine-color-${colorName}-${shade})`;
};

export const colorVar = getColorVar;
